module.exports = __webpack_public_path__ + "static/media/sample_institution.20d5e529.csv";